/***
 * 创建人：袁俊双
 * 时间：2019-10-28
 * 描述: 流程图组件
 * 更新说明: 
 * 使用说明:
 * 1. 直接展示在页面上  <sw-flow-chart [url]="pngUrl"></sw-flow-chart>
 * 2. 点击按钮弹出模态框 在点击事件中 : 
 * let param = {
      url:uri ,
      showModal:'yes'
    }
    this.create.createModal(SwFlowChartComponent,param,this.location.bind(this))
 */
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import * as Raphael from 'raphael';
import dagre from '../../../../../assets/Scripts/dagre/dagre.js';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwModalComponent } from '../../basic-components/sw-message/sw-modal.component';

@Component({
  selector: 'sw-flow-chart',
  templateUrl: './sw-flow-chart.component.html',
  styleUrls: ['./sw-flow-chart.component.css']
})
export class SwFlowChartComponent implements OnInit {

  /**
   * param : 使用创建模态框的方法时传入的参数,里面有两个数据,一个是请求路径 url; 一个是 showModal,值必须为 'yes' , 还可以有方向rankdir,值可以是 'horizontal',表示横向, 还可以是'vertical',表示纵向
   */
  @Input() param : any

  /**
   * callback : 抛出事件,点击流程图模态框的关闭事件触发
   */
  @Output() callback = new EventEmitter();
  
  /**
   * votedNode : 抛出事件,点击流程图某个节点抛出该节点信息
   */
  @Output() votedNode = new EventEmitter(); 

  /**
   * votedArrow : 抛出事件,点击流程图某个箭头抛出该箭头信息
   */
  @Output() votedArrow = new EventEmitter(); 

  /**
   * votedstatus : 抛出事件,流程图的查询结果,抛出 true 或 false
   */
  @Output() votedstatus = new EventEmitter(); 

  /**
   * @ignore
   * data : 查询到的节点的数据
   */
  data : any

  /**
   * url : 查询节点的请求路径
   */
  @Input() url : any

  /**
   * showModal : 是否是在模态框中展示 , 默认为"no",表示在页面中展示,为 "yes"的时候表示在模态框中展示
   */
  @Input() showModal : string = "no" 

  /**
   * selectedSid : 流程图初始化的时候默认选中的节点的 sid
   */
  @Input() selectedSid : string 

  /**
   * rankdir : 流程图方向
   */
  @Input() rankdir : string

  /**
   * @ignore
   * raduis : 节点的圆的半径 / 节点中图标的宽高
   */
  raduis:number = 21  

  /**
   * @ignore
   * graph : dagre创建的对象
   */
  graph:any


  @ViewChild('flowChartModal') flowChartModal:SwModalComponent

  //备注每行最大数
  MAX_MEMO_NUM = 5;
  //标题每行最大数
  MAX_LABEL_NUM = 5;
  //字体大小
  FONT_SIZE = 12;
  //节点默认宽高
  DEFAULT_SIZE = 42;

  selectedNode:any  //点击选中的节点
  selectedArrow:any  //选中的箭头
  selectedNodeColor:string  //选中节点修改之前的的填充色
  hoverRect:any  //鼠标悬浮出现的文本框
  hoverText:any  //鼠标悬浮出现的文本
  /**
   * @ignore
   * branchInfo : 分支信息
   */
  branchInfo:any 

   /**
   * @ignore
   * paper : 创建的纸张对象
   */
  paper:any  
  paperBoxId:string  //paper要初始化的元素的id
  isFull:boolean = false  //是否是全屏显示，一开始不是
  width:string = '1100px' //模态框的宽度
  height:string = '' //模态框的宽度
  clientW:string = ''  //视口宽度
  clientH:string = ''  //视口高度

  constructor(
    private http:SwHttpClientService, ) { }

  ngOnInit() {
    this.showModal = this.param && this.param.url ? this.param.showModal : this.showModal
    this.paperBoxId = 'myPaper'+new Date().getTime()
    this.url = this.url || this.param.url
    this.http.Post(this.url,{},{})
    .subscribe(res=>{
      if(res && res.code == 200){
        this.data = res.data
        if(Object.keys(this.data).length != 0){
          //流程图的查询结果不为空对象
          this.flowChartInit()
          if(this.selectedSid){
            let node = this.data.nodes.filter(item=>item.sid == this.selectedSid)[0]
            this.selectedNode = this.paper.getById(node.id)
            this.selectedNodeColor = this.selectedNode.attrs.fill
            this.selectedNode.attr({
              fill: '#654cd1',
            })
          }
        } else {
          //查询的结果为空对象,抛出false,让父组件知道
          this.votedstatus.emit(false)
        }
      }
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.selectedSid){
      let node = this.data.nodes.filter(item=>item.sid == this.selectedSid)[0]
      this.selectedNode = this.paper.getById(node.id)
      this.selectedNodeColor = this.selectedNode.attrs.fill
      this.selectedNode.attr({
        fill: '#654cd1',
      })
    }
    
  }

  /**
  * 点击关闭模态框触发,销毁组件,抛出 true , 要执行回调,为了让工作流中的查看流程图不能连续点击以及点击之后不能再点击其他操作按钮
  * @ignore
  */
  close(){
    this.callback.emit(true)
  }

  /**
  * 初始化流程图
  * @ignore
  */
  flowChartInit(){
    //r如果是动态创建模态框
    if(this.rankdir){
      this.data.rankdir = this.rankdir
    }
    if(this.param && this.param.rankdir){
      this.data.rankdir = this.param.rankdir || this.data.rankdir
    } 
    if(this.showModal == 'yes'){
      this.flowChartModal.toggle()
    }

    this.graph = new dagre.graphlib.Graph({});
    let rankdir = ''
    let marginx , marginy
    if(this.data.rankdir == 'horizontal'){
      rankdir = 'LR',  //LR表示从左到右
      marginx = 40,  //距离纸张左右两边的距离
      marginy = 60  //距离纸张上下两边的距离
      // this.MAX_LABEL_NUM = 5  //节点名称每行最大数
      // this.MAX_MEMO_NUM = 5;  //备注每行最大数
    } else if(this.data.rankdir == 'vertical'){
      rankdir = 'TB'  //TB表示从上到下
      marginx = 60,  //距离纸张左右两边的距离
      marginy = 40  //距离纸张上下两边的距离 
      // this.MAX_LABEL_NUM = 6  //节点名称每行最大数
      // this.MAX_MEMO_NUM = 6;  //备注每行最大数
    }
    let graphConfig = {
      rankdir:rankdir,
      nodesep:110+this.DEFAULT_SIZE,  //节点间的间距
      edgesep:50,  //水平分隔边缘的像素点
      ranksep:100,  //每个等级之间的距离
      marginx:marginx,  //距离纸张左右两边的距离
      marginy:marginy,  //距离纸张上下两边的距离
    }
    this.graph.setGraph(graphConfig);
    this.graph.setDefaultEdgeLabel(function() { return {}; });

    let edges = this.data.edges  //数据源中的箭头
    let nodes = this.data.nodes  //数据源中的节点
   
    edges.forEach(ed => {
      this.graph.setEdge(ed.from, ed.to, {
        label:ed.label,
        width: 2,
        height: 12,
        labelpos: 'l',
        labeloffset: '0',
        edgeId:ed.id,
        from:ed.from,
        to:ed.to
      });

    });

    //遍历节点数据开始画圆,背景图标,节点上的文字, 节点下的文字, 箭头
    nodes.forEach((v,i) => {
      this.graph.setNode(v.id, {
        label:v.text,
        image:v.image,
        width:this.DEFAULT_SIZE,
        height:this.DEFAULT_SIZE,
        memo:v.memo,
        state:v.state,
        sid:v.sid,
        nodeId:v.id
      });
    });
    
    //利用 dagre 对节点和箭头进行布局
    dagre.layout(this.graph)
    this.layoutNode()  //利用布局号的坐标开始画节点
    this.layoutEdge()  //利用布局号的坐标开始画箭头
  }

  //利用布局号的坐标开始画节点
  layoutNode(){
    let nodes = this.data.nodes  //数据源中的节点
    var elm= document.getElementById(this.paperBoxId)
    let boxWidth , boxHeight
    if(this.data.rankdir == 'horizontal'){
      //如果是横向的流程图
      boxWidth = 1200 //画布的宽度,默认1200
      let ends = nodes.filter(item=>item.text =='结束')  //根据有几个结束的节点来确定一共有几行
      let row = ends.length
      let height = [250,500,750,1000]
      boxHeight = height[row-1] //画布的高度,默认250 ,一行的高度
    } else if(this.data.rankdir == 'vertical'){
      //如果是纵向的流程图
      boxWidth = 400;
      boxHeight = 1200;
    }
    
    // 在浏览器视口中创建画布
    // 在元素中创建Raphael对象(推荐)
    // var raphaelObj = Raphael(x,y,width,height);
    // 这里的Raphael对象被初始化并且分配一个变量称为paper。这个变量被赋予RaphaelJS的所有权利。它从此以后成为Raphael画布对象。
    this.paper = Raphael(elm, boxWidth, boxHeight)
    this.paper.clear()

    let maxY = 0,
      maxX = 0;
    this.graph.nodes().forEach((v) => {
      let node = this.graph.node(v)
      // console.log("Node " + v + ": " + JSON.stringify(this.graph.node(v)));
      //根据节点信息中的 text 和 state 确定节点的图标和颜色
      let stateStyle = this.stateToStyle(node.state,node.label)
      let startX = node.x
      let startY = node.y  //节点的纵坐标加上100
      
      //重置容器宽高所需参数
      if (startY > maxY) {
        maxY = startY;
      }
      if (startX > maxX) {
        maxX = startX;
      }
      
      //开始画节点
      //画椭圆
      let ellipse  = this.paper.ellipse(startX, startY, this.DEFAULT_SIZE / 2 , this.DEFAULT_SIZE / 2)
        .attr({
          cursor: 'pointer',
          fill: stateStyle.nodeColor,
          stroke: '#cccccc',
          'stroke-width': '1px'
        }).click(() => {  //点击选中节点,修改选中样式
          // console.log(ellipse);
          if(ellipse.text == '开始'  || ellipse.text == '结束'){
            return
          }
          if(this.selectedNodeColor){  //已经有选中的节点
            this.paper.getById(this.selectedNode.id).attr({
              fill: this.selectedNodeColor,  //将之前选中节点的样式复原
            })
          }
          //将该节点的样式存入 selectedNodeColor 中
          this.selectedNodeColor = ellipse.attrs.fill 
          // console.log('this.selectedNodeColor',this.selectedNodeColor);
          
          this.selectedNode = ellipse
          // console.log('this.selectedNode',this.selectedNode);
          ellipse.attr({
            fill: '#654cd1',
          })
          this.votedNode.emit(this.selectedNode)
        }).hover((f_in)=>{  //鼠标悬浮在节点上,出现详情框
          // console.log('f_in');
          if(!this.hoverRect || !this.hoverText){
            // this.hoverRect = this.paper.rect(ellipse.getBBox().x2,ellipse.getBBox().y2,100,100).attr({
            //   fill: '#fff',
            //   stroke: '#cccccc',
            //   'stroke-width': '1px'
            // })
            // this.hoverText = this.paper.text(ellipse.getBBox().x2+50,ellipse.getBBox().y2+50,'哈哈哈哈哈哈').attr({
            //   fill: '#fff',
            //   stroke: '#cccccc',
            //   'stroke-width': '1px',
            //   'font-size': 13,
            // })
            // this.hoverRect.id = 10000
            // this.hoverText.id = 10001
            // console.log(this.hoverRect,this.hoverText);
          }
        },(f_out)=>{
          // console.log('f_out');
          // console.log(this.hoverRect,this.hoverText);
          // if(this.hoverRect && this.hoverText){
          //   this.paper.getById(10000).remove()
          //   this.paper.getById(10001).remove()
          //   this.hoverRect = undefined
          //   this.hoverText = undefined
          // }
          // console.log(this.hoverRect,this.hoverText);
        })
      ellipse.id = Number(node.nodeId)  //给当前节点设置id,值是节点的id,以便之后获取改节点
      ellipse.text = node.label  
      ellipse.sid = node.sid  
      ellipse.memo = node.memo  
      // console.log(ellipse);
      

      //开始画图标
      let image = this.paper.image(
            stateStyle.nodeIcon,
            startX - this.DEFAULT_SIZE / 4,
            startY - this.DEFAULT_SIZE / 4,
            this.DEFAULT_SIZE / 2,
            this.DEFAULT_SIZE / 2
          )
          .attr({
            cursor: 'pointer',
            fill: stateStyle.color
          })
          .click(() => {
          // console.log(ellipse.getBBox());
          // console.log(ellipse);
          if(ellipse.text == '开始'  || ellipse.text == '结束'){
            return
          }
          // console.log('image',image);
          // image.attr('src','assets/Images/flow-icons/pending.svg')
          if(this.selectedNodeColor){  //已经有选中的节点
            this.paper.getById(this.selectedNode.id).attr({
              fill: this.selectedNodeColor,
            })
          }
          this.selectedNode = this.paper.getById(image.id - 100)  // image的id - 100 = 节点的id
          this.selectedNodeColor = this.selectedNode.attrs.fill 
          this.selectedNode.attr({
            fill: '#654cd1',
          })
          this.votedNode.emit(this.selectedNode)
        }).hover((f_in)=>{  //鼠标悬浮在节点上,出现详情框
          if(!this.hoverRect || !this.hoverText){
          // console.log('image f_in');
          // this.hoverRect = this.paper.rect(this.paper.getById(image.id - 100).getBBox().x2,this.paper.getById(image.id - 100).getBBox().y2,100,100).attr({
          //   fill: '#fff',
          //   stroke: '#cccccc',
          //   'stroke-width': '1px'
          // })
          // this.hoverText = this.paper.text(this.paper.getById(image.id - 100).getBBox().x2+50,this.paper.getById(image.id - 100).getBBox().y2+50,'哈哈哈哈哈哈').attr({
          //   fill: '#fff',
          //   stroke: '#cccccc',
          //   'stroke-width': '1px',
          //   'font-size': 13,
          // })
          // this.hoverRect.id = 10000
          // this.hoverText.id = 10001
          } 
            
        },(f_out)=>{
          // console.log('image f_out');
        });
      image.id = Number(node.nodeId) + 100  //给当前节点设置id,值是节点的id加上100, 以便之后获取该节点

      let offsetTextX , offsetTextY , offsetMemoX , offsetMemoY
      if (this.data.rankdir === 'horizontal') {
        offsetTextX = startX
        offsetTextY = startY + this.DEFAULT_SIZE / 2 + 15  //节点下的文字
        offsetMemoX = startX
        offsetMemoY = startY - this.DEFAULT_SIZE / 2 - 15  //节点上的文字
        //如果节点名称超过限制，强制换行
        if (node.label && node.label.length > this.MAX_LABEL_NUM) {
          node.label = this.insert(node.label, this.MAX_LABEL_NUM);
          // offsetTextY += Math.ceil(node.label.length / this.MAX_LABEL_NUM) * 4;
        }
        
        //如果执行人超过限制，强制换行
        if (node.memo && node.memo.length > this.MAX_MEMO_NUM) {
          node.memo = this.insert(node.memo, this.MAX_MEMO_NUM);
          offsetMemoY -= Math.ceil(node.memo.length / this.MAX_MEMO_NUM) * 6;
        }
      } else {
        //纵向的流程图
        offsetTextX = startX + this.DEFAULT_SIZE + 15  //节点右侧偏上的文字,节点名称
        offsetTextY = startY - 12  //节点右侧偏上的文字,节点名称
        offsetMemoX = startX + this.DEFAULT_SIZE + 15  //节点右侧偏下的文字,执行人
        offsetMemoY = startY + 12  //节点右侧偏下的文字,执行人

        //如果只有节点名称而没有执行人的话,就将节点名称向下移到中间
        if(!node.memo && node.label){
          offsetTextY = startY
          node.label = this.insert(node.label, this.MAX_LABEL_NUM);
        }
          //如果节点名称超过限制，强制换行(节点执行人存在的前提下)
        if (node.memo && node.label && node.label.length > this.MAX_LABEL_NUM) {
          node.label = this.insert(node.label, this.MAX_LABEL_NUM);
          offsetTextY -= Math.floor(node.label.length / this.MAX_LABEL_NUM) * 8;
        }
        //根据节点名称的中心位置重新调整执行人的位置
        offsetMemoY = offsetTextY  + Math.ceil(node.label.length / this.MAX_LABEL_NUM) * 10 +15;
        //如果执行人超过限制，强制换行,
        if (node.memo && node.memo.length > this.MAX_MEMO_NUM) {
          node.memo = this.insert(node.memo, this.MAX_MEMO_NUM);
          // offsetMemoY += Math.floor(node.memo.length / this.MAX_MEMO_NUM) * 8;
        }
        
      }

      
      //节点下文字 text
      // console.log('----------节点下文字',startX,offsetTextY,node.label);
      // let aa = this.paper.rect(startX, offsetTextY,2,2)
      let text = this.paper
        .text(offsetTextX, offsetTextY, node.label)
        .attr({
          fill: stateStyle.color,
          'font-size': 13,
          'font-weight':700,
          cursor: 'pointer'
        })
      //手动将 tspan标签的dy属性设置为4,避免偏移太多
      let textTspan = text[0].firstElementChild
      textTspan.setAttribute('dy',4)
        // console.log(text);
        

      //节点上的文字
      // console.log('----------节点上文字',startX,offsetMemoY,node.memo);
      // let bb = this.paper.rect(startX, offsetMemoY,2,2)
      let memo = this.paper
        .text(offsetMemoX, offsetMemoY, node.memo)
        .attr({
          fill: '#888',
          'font-size': 12,
          cursor: 'pointer'
        })
      //手动将 tspan标签的dy属性设置为4,避免偏移太多
      let memoTspan = memo[0].firstElementChild
      memoTspan.setAttribute('dy',4)

      // console.log(memo);
      
    });
    let reSizeWidth, reSizeHeight;

    if (this.data.rankdir === 'horizontal') {
      reSizeWidth = maxX + 64;
      reSizeHeight = maxY + 130;
    } else {
      //纵向的流程图
      reSizeWidth = maxX + 110;
      reSizeHeight = maxY + 64;
    }
    //重置容器宽高度
    this.paper.setSize(reSizeWidth, reSizeHeight);
    
  }

  //利用布局号的坐标开始画箭头
  layoutEdge(){
    this.graph.edges().forEach((e)=> {
      let rotate = "R0"  //箭头上的文字的旋转角度,直线上角度为0,分支箭头上的文字旋转90度
      // console.log("Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)));
      const edge = this.graph.edge(e);
      //开始节点
      let fromNode = this.paper.getById(Number(edge.from))  //箭头的from节点
      //结束节点
      let toNode = this.paper.getById(Number(edge.to))  //箭头的from节点
      let startX, startY, endX, endY
      if (this.data.rankdir === 'horizontal') {
        startX = fromNode.attrs.cx + this.DEFAULT_SIZE/2 + 5  //开始节点的横坐标+ this.DEFAULT_SIZE/2 + 5 
        startY = fromNode.attrs.cy  //开始节点的纵坐标
        endX = toNode.attrs.cx //结束节点的横坐标
        endY = toNode.attrs.cy  //结束节点的纵坐标
      } else {
        //纵向的流程图
        startX = fromNode.attrs.cx   //开始节点的横坐标+ this.DEFAULT_SIZE/2 + 5 
        startY = fromNode.attrs.cy + this.DEFAULT_SIZE/2 + 5 //开始节点的纵坐标
        endX = toNode.attrs.cx //结束节点的横坐标
        endY = toNode.attrs.cy  //结束节点的纵坐标
      }
      // console.log('上个节点fromNode',fromNode,startX,startY);
      
      const points = edge.points;
      //折线路径
      let path;
      //箭头文字的位置,默认在开始和结束中间
      let labelX = startX + (points[points.length-1].x - startX) /2
      let labelY = startY + (points[points.length-1].y - startY) /2
      if(this.data.rankdir == 'horizontal'){
        //如果是横向的流程图
        if(points.length == 3){
          // console.log(points.length);
          if(points[0].y == points[1].y && points[2].y == points[1].y) {  //如果第一个点和第二个点的纵坐标一致,说明是直线箭头
            // 1. 直线箭头
            // console.log('直线箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x - 5},${points[2].y }`;
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
          } else if(points[0].y > points[1].y && points[2].y == points[1].y){ //第一个点在第二个点的下面,说明是向上的折线
            // 2. 先向上后直的折线箭头
            // console.log('先向上后直的折线箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            path = `M${startX},${startY}L${startX + 40},${startY} L${startX + 40},${points[1].y} L${points[2].x - 5},${points[2].y }`;
            if (edge.label && edge.label.length > 1) {
              if(Math.abs(points[2].y - startY) < edge.label.length*15){
                edge.label = this.insert(edge.label, 2);
                labelX = startX + 25
                labelY = labelY - edge.label.length/4*4
              } else {
                edge.label = this.insert(edge.label, 1);
                labelX = startX + 30
                labelY = labelY - edge.label.length/2*4
              }
            } 
          } else if(points[0].y < points[1].y && points[2].y == points[1].y){
            // 3. 先向下后直的折线箭头
            // console.log('先向下后直的折线箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            path = `M${startX},${startY} L${startX + 40},${startY} L${startX + 40},${points[2].y}L${points[2].x - 5},${points[2].y }`;
            if (edge.label && edge.label.length > 1) {
              if(Math.abs(points[2].y - startY) < edge.label.length*15){
                edge.label = this.insert(edge.label, 2);
                labelX = startX + 25
                labelY = labelY - edge.label.length/4*4
              } else {
                edge.label = this.insert(edge.label, 1);
                labelX = startX + 30
                labelY = labelY - edge.label.length/2*4
              }
            }
          } else if(points[0].y == points[1].y && points[2].y > points[1].y){
            // 4. 先直后向下的折线箭头
            // console.log('先直后向下的折线箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x - 5},${points[2].y }`;
            //箭头上文字的坐标根据索引为 1 , 2 决定
            labelX = points[1].x 
            labelY = points[1].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
              labelX = points[1].x 
              labelY -= Math.ceil(edge.label.length / 6) * 6;
            }
          } else if(points[0].y == points[1].y && points[2].y < points[1].y){
            // 5.先直后向上的折线箭头
            // console.log("先直后向上的折线箭头","Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)));
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x - 5},${points[2].y }`;
            //箭头上文字的坐标根据索引为 1 , 2 决定
            labelX = points[1].x 
            labelY = points[1].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
              labelX = points[1].x 
              labelY -= Math.ceil(edge.label.length / 6) * 6;
            } 
          } else if(points[0].y == points[2].y && points[0].x < points[2].x && points[0].y > points[1].y){
            //6.先右上后右下的箭头，直接拉直
            // console.log("先右上后右下的箭头","Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)));
            path = `M${startX},${startY} L${endX  -this.DEFAULT_SIZE/2 - 5},${endY }`;
            //箭头上文字的坐标根据索引为 1 , 2 决定
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
          } else if(points[0].y == points[2].y && points[0].x > points[2].x && points[0].y < points[1].y){
            //7.先左下后左上的箭头，改成 下-左-上 的箭头
            // console.log("先左下后左上的箭头","Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)));
            path = `M${startX -this.DEFAULT_SIZE/2 - 5},${startY +this.DEFAULT_SIZE/2 + 5}L${startX -this.DEFAULT_SIZE/2 - 5},${points[1].y } L${endX},${points[1].y }L${endX },${endY +this.DEFAULT_SIZE/2 + 5  }`;
            //箭头上文字的坐标根据索引为 1 , 2 决定
            labelX = startX + (endX - startX) /2
            labelY = points[1].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
          } else{
            // console.log("是其他类型的三点箭头");
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x },${points[2].y }`;
          }
  
        } else if(points.length == 5){
          // console.log(points.length); 
          // 1. 如果有返回的箭头
          if(points[0].x > points[1].x){
            // console.log('开始--左下--左--左--左上',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //开始--左下--左--左--左上
            path = `M${startX -this.DEFAULT_SIZE/2 - 5},${startY +this.DEFAULT_SIZE/2 + 5} L${startX -this.DEFAULT_SIZE/2 - 5},${points[1].y}L${endX},${points[2].y} L${endX},${points[4].y}`;
            //箭头上文字的坐标根据开始节点和结束节点 决定
            labelX = startX + (endX - startX) /2
            labelY = points[3].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
  
          } else if(points[0].x < points[1].x && points[1].y == points[3].y){ 
            // console.log('开始--右下--右--右--右上',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //开始--右下--右--右--右上  要变成  开始--右--下--右--右上
            path = `M${startX},${startY} L${startX + 40},${startY}L${startX + 40},${points[2].y} L${points[3].x},${points[3].y} L${points[4].x},${points[4].y}`;
            //箭头上文字的坐标根据开始节点和结束节点 决定
            labelX = startX + (endX - startX) /2
            labelY = points[3].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
              labelY = labelY - edge.label.length/6*4
            }
          } else{
            // console.log("是其他类型的五点箭头");
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x },${points[2].y }L${points[3].x },${points[3].y }L${points[4].x },${points[4].y }`;
          }
  
        } else if(points.length == 7){
          // console.log(points.length);
          if(points[0].y == points[6].y && points[1].y == points[5].y && points[0].x < points[1].x && points[0].y > points[3].y){
            // console.log('开始--右上--右--右--右--右--右下 的箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //如果是 开始--右上--右--右--右--右--右下  的箭头
            path = `M${startX},${startY} L${startX + 40},${startY}L${startX + 40},${points[2].y}L${points[3].x},${points[3].y}L${points[4].x},${points[4].y}L${points[5].x},${points[5].y}L${points[6].x},${points[6].y}`;
            //箭头上文字的坐标根据开始节点和结束节点 决定
            labelX = startX + (endX - startX) /2
            labelY = points[3].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
  
          } else if(points[0].y == points[6].y && points[1].y == points[5].y && points[0].x < points[1].x && points[0].y < points[3].y){
            // console.log('开始--右下--右--右--右--右--右上  的箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //如果是 开始--右下--右--右--右--右--右上  的箭头
            path = `M${startX},${startY} L${startX + 40},${startY}L${startX + 40},${points[2].y}L${points[3].x},${points[3].y}L${points[4].x},${points[4].y}L${points[5].x},${points[5].y}L${points[6].x},${points[6].y}`;
            //箭头上文字的坐标根据开始节点和结束节点 决定
            labelX = startX + (endX - startX) /2
            labelY = points[3].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
  
          } else if(points[0].y == points[6].y && points[0].x < points[6].x && points[6].x - points[0].x  <= this.DEFAULT_SIZE/2){
            // console.log("自己指向自己的箭头","Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)));
            path = `M${startX-5-this.DEFAULT_SIZE+10},${startY+this.DEFAULT_SIZE/2} L${startX-5-this.DEFAULT_SIZE+10},${startY+this.DEFAULT_SIZE/2+60} L${startX-5-10},${startY+this.DEFAULT_SIZE/2+60 }L${startX-5-10 },${points[6].y }`;
          } else {
            // console.log("是其他类型的七点箭头","Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)));
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x },${points[2].y }L${points[3].x },${points[3].y }L${points[4].x },${points[4].y }L${points[5].x },${points[5].y }L${points[6].x },${points[6].y }`;

          }
  
        } else if(points.length == 9){
          // console.log(points.length);
          if(points[0].x > points[1].x && points[0].y < points[1].y && points[1].y == points[7].y) {
            // console.log('开始--左下--左--左--左--左--左--左--左上',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            
            //开始--左下--左--左--左--左--左--左--左上
            path = `M${startX -this.DEFAULT_SIZE/2 -5},${startY +this.DEFAULT_SIZE/2 + 5} L${startX -this.DEFAULT_SIZE/2 -5},${points[1].y} L${endX},${points[7].y } L${endX},${endY +this.DEFAULT_SIZE/2 + 5 }`;
            //箭头上文字的坐标根据开始节点和结束节点 决定
            labelX = startX + (endX - startX) /2
            labelY = points[3].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
  
          } else if(points[0].x > points[8].x && points[0].y == points[1].y && points[1].y == points[7].y){
            // console.log('左--左--左--左--左--左--左--左--左上',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //左--左--左--左--左--左--左--左--左上
            path = `M${startX -this.DEFAULT_SIZE -5},${startY} L${endX},${points[7].y } L${endX},${endY +this.DEFAULT_SIZE/2 + 5 }`;
            //箭头上文字的坐标根据开始节点和结束节点 决定
            labelX = startX + (endX - startX) /2
            labelY = points[3].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
          } else{
          //  console.log("是其他类型的九点箭头");
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x },${points[2].y }L${points[3].x },${points[3].y }L${points[4].x },${points[4].y }L${points[5].x },${points[5].y }L${points[6].x },${points[6].y }L${points[7].x },${points[7].y }L${points[8].x },${points[8].y }`;
              //箭头上文字的坐标根据开始节点和结束节点 决定  ==>zll
              labelX = startX + (endX - startX) /2
              labelY = points[3].y - 2
              if (edge.label && edge.label.length > 6) {
                edge.label = this.insert(edge.label, 6);
              }
          }
  
        } else{
          // 其他类型箭头
        //  console.log("其他类型箭头","Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)));
          path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x - 5},${points[2].y }`;
          //箭头上文字的坐标根据索引为 1 , 2 决定
          labelX = points[1].x 
          labelY = points[1].y - 2
          if (edge.label && edge.label.length > 6) {
            edge.label = this.insert(edge.label, 6);
            labelX = points[1].x 
            labelY -= Math.ceil(edge.label.length / 6) * 6;
          }
        }
      } else if(this.data.rankdir == 'vertical'){
        //如果是纵向的流程图
        // console.log(points.length);
        if(points.length == 3){
          if(points[0].x == points[1].x && points[2].x == points[1].x) {  //三个点的横坐标一样,是向下的直线箭头
            // 1. 向下的直线箭头
            // console.log('向下的直线箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x},${points[2].y }`;
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
          } else if(points[0].x > points[1].x && points[2].x == points[1].x){ 
            // 2. 将开始--左下--下  改为 开始--下--左--下  的折线箭头
            // console.log('开始--左下--下折线箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            path = `M${startX},${startY}L${startX },${startY + 40} L${points[1].x},${startY + 40} L${points[2].x},${points[2].y }`;
            labelY = startY + 22
            if (edge.label && edge.label.length > 5) {
              edge.label = this.insert(edge.label, 5);
              labelY -= Math.floor(edge.label.length / 5) * 6;
            } 
          } else if(points[0].x < points[1].x && points[2].x == points[1].x){
            // 3. 将开始--右下--下  改为 开始--下--右--下  的折线箭头
            // console.log('开始--右下--下的折线箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            path = `M${startX},${startY} L${startX},${startY + 40} L${points[2].x},${startY + 40}L${points[2].x},${points[2].y }`;
            labelY = startY + 22
            if (edge.label && edge.label.length > 5) {
              edge.label = this.insert(edge.label, 5);
              labelY -= Math.floor(edge.label.length / 5) * 6;
            }
          } else if(points[0].x == points[1].x && points[2].x > points[1].x){
            // 4. 开始--下--右下 的折线箭头
            // console.log('开始--下--右下的折线箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x},${points[2].y - 5}`;
            //箭头上文字的坐标根据索引为 1 , 2 决定
            labelX = points[1].x 
            labelY = points[1].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
              labelX = points[1].x 
              labelY -= Math.ceil(edge.label.length / 6) * 6;
            }
          } else if(points[0].x == points[1].x && points[2].x < points[1].x){
            // 5.开始--下--左下的折线箭头
            // console.log("开始--下--左下的折线箭头","Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)));
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x},${points[2].y - 5}`;
            //箭头上文字的坐标根据索引为 1 , 2 决定
            labelX = points[1].x 
            labelY = points[1].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
              labelX = points[1].x 
              labelY -= Math.ceil(edge.label.length / 6) * 6;
            } 
          } else{
            //console.log("是其他类型的三点箭头");
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x },${points[2].y }`;
          }
  
        } else if(points.length == 5){
          // console.log(points.length); 
          // 1. 如果有返回的箭头
          if(points[0].x = points[4].x && points[1].x == points[2].x && points[2].x == points[3].x && points[0].x > points[1].x && points[0].y < points[1].y){
            // console.log('开始--左下--下--下--右下',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //开始--左下--下--下--右下
            path = `M${startX},${startY} L${startX},${startY + 40}L${points[1].x},${startY + 40}L${points[2].x},${points[2].y} L${points[3].x},${points[3].y}L${points[4].x},${points[4].y}`;
            //箭头上文字的在下的那条线左边,竖着排
            labelX = points[1].x - 10
            labelY = points[2].y 
            if (edge.label && edge.label.length > 1) {
              edge.label = this.insert(edge.label, 1);
              labelY -= Math.ceil(edge.label.length / 1) * 4;
            }
  
          } else if(points[0].x = points[4].x && points[1].x == points[2].x && points[2].x == points[3].x && points[0].x < points[1].x && points[0].y < points[1].y){ 
            // console.log('开始--右下--下--下--左下',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //开始--右下--下--下--左下 
            path = `M${startX},${startY} L${startX},${startY + 40}L${points[1].x},${startY + 40}L${points[2].x},${points[2].y} L${points[3].x},${points[3].y}L${points[4].x},${points[4].y}`;
            //箭头上文字的在下的那条线右边,竖着排
            labelX = points[1].x + 10
            labelY = points[2].y 
            if (edge.label && edge.label.length > 1) {
              edge.label = this.insert(edge.label, 1);
              labelY -= Math.ceil(edge.label.length / 1) * 4;
            }
          } else{
            //console.log("是其他类型的五点箭头");
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x },${points[2].y }L${points[3].x },${points[3].y }L${points[4].x },${points[4].y }`;
          }
  
        } else if(points.length == 7){
          if(points[0].x == points[6].x && points[1].x == points[5].x && points[0].y < points[1].y && points[0].x > points[3].x){
            // console.log('开始--右下--下--下--下--下--左下 的箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //如果是 开始--右下--下--下--下--下--左下 的箭头
            path = `M${startX},${startY} L${startX},${startY + 40}L${points[2].x},${startY + 40}L${points[3].x},${points[3].y}L${points[4].x},${points[4].y}L${points[5].x},${points[5].y}L${points[6].x},${points[6].y}`;
            //箭头上文字的坐标根据开始节点和结束节点 决定
            labelX = startX + (endX - startX) /2
            labelY = points[3].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
  
          } else if(points[0].x == points[6].x && points[1].x == points[5].x && points[0].y < points[1].y && points[0].x < points[3].x){
            // console.log('开始--左下--下--下--下--下--右下  的箭头',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //如果是 开始--左下--下--下--下--下--右下  的箭头
            path = `M${startX},${startY} L${startX},${startY + 40}L${points[2].x},${startY + 40}L${points[3].x},${points[3].y}L${points[4].x},${points[4].y}L${points[5].x},${points[5].y}L${points[6].x},${points[6].y}`;
            //箭头上文字的坐标根据开始节点和结束节点 决定
            labelX = startX + (endX - startX) /2
            labelY = points[3].y - 2
            if (edge.label && edge.label.length > 6) {
              edge.label = this.insert(edge.label, 6);
            }
  
          } else{
            //console.log("是其他类型的七点箭头");
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x },${points[2].y }L${points[3].x },${points[3].y }L${points[4].x },${points[4].y }L${points[5].x },${points[5].y }L${points[6].x },${points[6].y }`;
          }
  
        } else if(points.length == 9){
          // console.log(points.length); 
          // 1. 如果有返回的箭头
          if(points[0].x = points[8].x && points[1].x == points[2].x && points[2].x == points[3].x && points[0].x > points[1].x && points[0].y < points[1].y){
            // console.log('开始--左下--下--下--下--下--下--下--右下',"Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)))
            //开始--左下--下--下--右下
            path = `M${startX},${startY} L${startX},${startY + 40}L${points[1].x},${startY + 40}L${points[2].x},${points[2].y} L${points[3].x},${points[3].y}L${points[8].x},${points[8].y}`;
            //箭头上文字的在下的那条线左边,竖着排
            labelX = points[1].x - 10
            labelY = points[2].y 
            if (edge.label && edge.label.length > 1) {
              edge.label = this.insert(edge.label, 1);
              labelY -= Math.ceil(edge.label.length / 1) * 4;
            }
  
          } else{
            // console.log("是其他类型的九点箭头");
            path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[2].x },${points[2].y }L${points[3].x },${points[3].y }L${points[4].x },${points[4].y }L${points[5].x },${points[5].y }L${points[6].x },${points[6].y }L${points[7].x },${points[7].y }L${points[8].x },${points[8].y }`;
          }
  
        } else{
          // 其他类型箭头
          // console.log("其他类型箭头","Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(this.graph.edge(e)));
          path = `M${startX},${startY} L${points[1].x},${points[1].y} L${points[points.length-2].x},${points[points.length-2].y }L${points[points.length-1].x },${points[points.length-1].y}`;
          //箭头上文字的坐标根据索引为 1 , 2 决定
          labelX = points[1].x 
          labelY = points[1].y - 2
          if (edge.label && edge.label.length > 6) {
            edge.label = this.insert(edge.label, 6);
            labelX = points[1].x 
            labelY -= Math.ceil(edge.label.length / 6) * 6;
          }
        }
      }
      
      

      //箭头直线
      let arrow = this.paper.path(path).attr({
        'arrow-end': 'block-wide-long',
        stroke: "#ccc",
        "stroke-width": 2,
        cursor: 'pointer',
      }).click(() => {  //点击箭头
       // console.log(arrow); 
        if(this.selectedArrow){
          //如果已经有选中的箭头,就将该箭头颜色还原
          this.paper.getById(this.selectedArrow.id).attr({
            // stroke: "#ccc",
            "stroke-width": 2
          })
        }
        this.selectedArrow = arrow  //给选中的箭头重新赋值
        this.selectedArrow.attr({  //给选中的箭头改变颜色
          // stroke: '#654cd1',
          "stroke-width": 4
        })
        this.votedArrow.emit(this.selectedArrow)  //将选中箭头抛出
      });
      arrow.id = e.v+'-'+e.w  //给该箭头设置id,  e.v是箭头的起始节点id, e.w是箭头的终止节点的id

      //箭头直线上的文字
      if (this.data.rankdir === 'horizontal') {
        labelY = labelY-12
      }
      if(edge.label){
        // console.log('箭头文字的坐标:',labelX,labelY);
        let edgeLabel = this.paper
        .text(labelX, labelY,  edge.label)
        .attr({
          fill: '#888',
          'font-size': this.FONT_SIZE
        })
        //手动将 tspan标签的dy属性设置为4,避免偏移太多
        let edgeLabelTspan = edgeLabel[0].firstElementChild
        edgeLabelTspan.setAttribute('dy',4)
        // console.log(edgeLabel);
        
      }
        
    });
  }
 
  
  /**
   * 根据状态和 text 显示对应的图标
   * @param {*} state
   * @param {*} text
   */
  stateToStyle(state, text) {
    let color, stateIcon, nodeIcon, nodeColor;

    switch (state) {
      case 'resolve':
        color = '#00cc7a';
        stateIcon = 'assets/Images/flow-icons/resolve.svg';
        nodeIcon = 'assets/Images/flow-icons/node_resolve.svg';
        nodeColor = '#00cc7a';
        break;
      case 'pending':
        color = '#3399ff';
        stateIcon = 'assets/Images/flow-icons/pending.svg';
        nodeIcon = 'assets/Images/flow-icons/node_pending.svg';
        nodeColor = '#3399ff';
        break;
      case 'undisposed':
        color = '#555555';
        stateIcon = 'assets/Images/flow-icons/undisposed.svg';
        nodeIcon = 'assets/Images/flow-icons/node_undisposed.svg';
        nodeColor = '#8c8c8c';
        break;
      default:
        nodeIcon = 'assets/Images/flow-icons/project.svg';
        stateIcon = 'assets/Images/flow-icons/undisposed.svg';
        nodeColor = '#006FFF';
        break;
    }
    if (text === '开始') {
      nodeIcon = 'assets/Images/flow-icons/node_start.svg';
      nodeColor = '#006FFF';
    }
    if (text === '结束') {
      nodeIcon = 'assets/Images/flow-icons/node_end.svg';
      nodeColor = '#006FFF';
    }
    return {
      color,
      stateIcon,
      nodeIcon,
      nodeColor
    };
  }


  /**
   * 将过长的节点换行
   * @param {*} str
   * @param {*} num
   */

  insert(str, num) {
    str = str.replace('\n', '');
    const x = Math.ceil(str.length / num);
    let arr = str.split('');
    for (let i = 0; i < x; i++) {
      arr.splice(num * (i + 1) + i, 0, '\n');
    }
    return arr.join('');
  }

  //点击放大至全屏
  toFull(){
    this.clientW = document.documentElement.clientWidth + 'px'
    this.clientH = document.documentElement.clientHeight - 68 + 'px'
    
    this.width = this.clientW
    this.height = this.clientH
    this.isFull = true
  }

  //点击缩小至原来大小
  toInit(){
    this.width = '1100px'
    this.height = ''
    this.isFull = false

  }
}
